import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomDialog from "../../../../../global/components/CustomModal/CustomModal";
import SignUpOtpStyles from './SignUpOtp.styles';
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import { Link } from "react-router-dom";
import {ReactComponent as BackArrowIcon }from '../../../../../assets/icons/ArrowLeft.svg';
import OtpInput from "../../../../../global/components/OtpInput/OtpInput";

interface CustomProps {
  showVerifyDialog:boolean;
  handleClose : Function;
  setShowVerifyDialog?: boolean;
}

const SignUpOtp = (props : CustomProps) => {
    const classes = SignUpOtpStyles;

    const [otpValue, setOtpValue] = useState("");

    const handleOtpChange = (value: string) => {
      setOtpValue(value);
    };

     const handleBackButton = () =>{
      props.handleClose();
     }
 

   const dialogTitleContent = () =>{
    return(
      <>
     <Box>
          <Box sx={classes.cardHeader}>
            <Typography sx={classes.cardTitle}>Mobile Verfication</Typography>
            <Typography sx={classes.cardSubText}>
            6 digit OTP verification sent on +91 991 686 6611
            </Typography>
            <Typography sx={classes.emailIdLink}> <Link to= "/" >Use email instead</Link></Typography>        
          </Box>

          <Box sx={classes.cardContent}>
          <OtpInput value={otpValue} onChange={handleOtpChange} />
          </Box>
          <Box>
            <Typography sx={classes.sendOtpMgs}>Didn’t receive, Resend OTP in 60 sec</Typography>
          </Box>
          <Box sx={classes.cardFooter}>
            <CustomButton
              label="Verify & Proceed"
              buttonType="primaryBtn"
              onClick={() => {}}
            />
            
            <CustomButton label="Back to Sign up" startIcon={<BackArrowIcon/>} onClick={() => {handleBackButton()}} />
          </Box>
        </Box>
      </>
    )
   }

  const getSignUpOtp = () => {
    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <CustomDialog
              isDialogOpen={props.showVerifyDialog}
              dialogTitleContent={dialogTitleContent()}
              handleDialogClose={props.handleClose}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  return getSignUpOtp();
};

export default SignUpOtp;
